import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

// Load all translation files for each language
const enFiles = import.meta.glob('./locales/en/*.json', { eager: true });
const esFiles = import.meta.glob('./locales/es/*.json', { eager: true });

// Process files and create namespaces
const processFiles = (files: Record<string, any>): Record<string, any> => {
  const result: Record<string, any> = {};

  Object.entries(files).forEach(([path, module]) => {
    const fileName = path.split('/').pop()?.replace('.json', '');
    if (fileName) {
      result[fileName] = module.default || module;
    }
  });

  return result;
};

// Initialize resources structure
const initializeResources = async () => {
  // Process language files
  const enResources = processFiles(enFiles);
  const esResources = processFiles(esFiles);

  // Create resources object
  const resources = {
    en: enResources,
    es: esResources,
  };

  if (import.meta.env.DEV) {
    console.log('Loaded translations:', resources);
  }

  return resources;
};

// Initialize i18n
const initializeI18n = async () => {
  const resources = await initializeResources();

  i18n
    .use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      resources,
      fallbackLng: 'en',
      debug: import.meta.env.DEV,

      // List all namespaces (file names)
      ns: Object.keys({ ...resources.en, ...resources.es }),
      defaultNS: 'common',

      interpolation: {
        escapeValue: false, // not needed for react as it escapes by default
      },
    });
};

// Initialize i18n
initializeI18n();

export default i18n;
